import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-lfsa-alerts',
  templateUrl: './lfsa-alerts.component.html',
  styleUrls: ['./lfsa-alerts.component.css']
})
export class LfsaAlertsComponent implements OnInit {

  @Input() texto?: string = "No se encontraron datos...";
  @Input() listaVacia: boolean;
  @Input() loading: boolean;
  @Input() class?: string = 'danger';
  
  constructor() { }

  ngOnInit(): void {
  }

}
